var countdownIntervals;

function replaceOrRemove(str, num, target) {
  if (!str || str.length === 0) {
    return '';
  }
  if (num > 0) {
    return str.replace(target, num);
  }
  return str
    .split(' ')
    .filter((word) => !word.includes(target))
    .join(' ');
}

function enforceMaxLength(str, maxLength) {
  if (typeof str !== 'string') return '';
  return str.length > maxLength ? str.slice(0, maxLength) : str;
}

function getDateInStoreTimezone(dateTimeString = '') {
  const date = dateTimeString ? new Date(dateTimeString) : new Date();
  date.setHours(date.getHours() - window.shopHoursDifference);
  return date;
}

function initCountdowns() {
  const countdownElements = document.querySelectorAll('.promotional-banner[data-countdown]');
  countdownElements.forEach(function (el) {
    const endTimeStr = el.getAttribute('data-countdown');
    const timeExpiredStr = el.getAttribute('data-timer-expired');
    const timeFormatStr = el.getAttribute('data-timer-format');

    if (!endTimeStr || !timeFormatStr || !timeExpiredStr) {
      el.classList.remove('waiting-js');
      return;
    }

    const countdownEl = el.querySelector('.countdown-timer');
    const endTime = new Date(endTimeStr).getTime(); // endTimeStr is already in store's timezone

    function updateCountdown() {
      const now = getDateInStoreTimezone().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        countdownEl.innerHTML = enforceMaxLength(timeExpiredStr, 30);
        return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let output = replaceOrRemove(timeFormatStr, hours, '[HH]'); // hide hours when zero
      output = output.replace('[MM]', minutes).replace('[SS]', seconds); // always show minutes & seconds

      countdownEl.innerHTML = enforceMaxLength(output, 30);
    }

    updateCountdown();
    countdownIntervals.set(el, setInterval(updateCountdown, 1000));
    el.classList.remove('waiting-js');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  countdownIntervals = new Map();
  initCountdowns();
});

window.addEventListener('shopify:section:load', function (event) {
  initCountdowns();
});

window.addEventListener('shopify:section:unload', function (event) {
  const sectionEl = document.getElementById(`shopify-section-${event.detail.sectionId}`);
  if (!sectionEl) return;

  const countdownElements = sectionEl.querySelectorAll('.promotional-banner[data-countdown]');
  countdownElements.forEach(function (el) {
    const intervalId = countdownIntervals.get(el);
    if (intervalId) {
      clearInterval(intervalId);
      countdownIntervals.delete(el);
    }
  });
});
